import { HellodialogClient } from "../../../../Shared/backendApi/hellodialog.generated";
import { extendedHttpResult } from "../../../../Shared/backendApi/utils";
const client = new HellodialogClient(window.location.origin);
const token = ()=>document.getElementsByName("__RequestVerificationToken")[0].value;
export const submitForm = (data)=>extendedHttpResult(()=>client.inschrijven(token(), toRequest(data)));
const toRequest = (data)=>({
        email: data.emailAddress,
        voornaam: data.firstName,
        achternaam: data.lastName,
        geslacht: data.gender,
        groups: data.newsletters.toArray(),
        _state: "Contact",
        _language: "NL"
    });
